<script>
import { Line } from "vue-chartjs";
import { getStyle, hexToRgba } from "@coreui/coreui/dist/js/coreui-utilities";
import { CustomTooltips } from "@coreui/coreui-plugin-chartjs-custom-tooltips";
import { random } from "@/shared/utils";
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  extends: Line,
  props: ["height"],
  computed: {
    ...mapState(["mcap", "notification"]),
    ...mapActions("notification", ["add", "remove"])
  },
  methods: {
    LoadRecipientData() {
      //this.ReversedMonthsForRecipients = this.$store.state.mcap.months;
      // for (var m in this.ReversedMonthsForRecipients) {
      //   this.ClientDirectRecipientTrendData.push(
      //     this.$store.state.mcap.months[m].MonthlyRecipientCount
      //   );
      //   this.ClientDirectRecipientTrendLabels.push(
      //     this.$store.state.mcap.months[m].Description.replace(" IOV", "")
      //   );
      // }
      // return true;

      for (var m in this.$store.state.mcap.months) {
        this.ClientDirectRecipientTrendData.push(
          //this.$store.state.mcap.months[m].OrderCount
          this.$store.state.mcap.months[m].MonthlyRecipientCount
        );
        //alert(this.$store.state.mcap.months[m].OrderCount);
        this.ClientDirectRecipientTrendLabels.push(
          this.$store.state.mcap.months[m].Description.replace(" IOV", "")
        );
      }
      // return new Promise((resolve, reject) => {
      //   if (this.ClientDirectTrendData.length > 0) {
      //     resolve(true);
      //   } else {
      //     reject(false);
      //   }
      // });
    }
  },
  data: () => {
    return {
      ClientDirectRecipientTrendData: [],
      ClientDirectRecipientTrendLabels: [],
      ReversedMonthsForRecipients: [],
      brandInfo: getStyle("--info") || "#20a8d8"
    };
  },
  mounted() {
    // const brandSuccess = getStyle("--success") || "#4dbd74";
    // const brandDanger = getStyle("--danger") || "#f86c6b";
    // for (let i = 0; i <= elements; i++) {
    //   data1.push(random(50, 200));
    //   data2.push(random(80, 100));
    //   data3.push(65);
    // }

    this.$store
      .dispatch("mcap/getMonths")
      .then(() => {
        this.LoadRecipientData();
      })
      .then(() => {
        this.renderChart(
          {
            labels: this.ClientDirectRecipientTrendLabels.reverse(),
            datasets: [
              {
                label: "Client Direct Trends",
                backgroundColor: hexToRgba(this.brandInfo, 10),
                borderColor: this.brandInfo,
                pointHoverBackgroundColor: "#fff",
                borderWidth: 2,
                data: this.ClientDirectRecipientTrendData.reverse()
              }
            ]
          },
          {
            tooltips: {
              enabled: false,
              custom: CustomTooltips,
              intersect: true,
              mode: "index",
              position: "nearest",
              callbacks: {
                labelColor: function(tooltipItem, chart) {
                  return {
                    backgroundColor:
                      chart.data.datasets[tooltipItem.datasetIndex].borderColor
                  };
                }
              }
            },
            maintainAspectRatio: false,
            responsive: true,
            legend: {
              display: false
            },
            scales: {
              xAxes: [
                {
                  gridLines: {
                    drawOnChartArea: false
                  }
                }
              ],
              yAxes: [
                {
                  ticks: {
                    beginAtZero: false,
                    maxTicksLimit: 5,
                    stepSize: Math.ceil(250 / 5)
                  },
                  gridLines: {
                    display: true
                  }
                }
              ]
            },
            elements: {
              point: {
                radius: 2,
                hitRadius: 10,
                hoverRadius: 4,
                hoverBorderWidth: 1
              }
            }
          }
        );
      });
  }
};
</script>
